import Create from './create/CreateClientAccount';
import Edit from './edit/EditClientAccount';
import Individual from './individual/ClientAccount';
import List from './list/ClientAccounts';

export default { Create, Edit, Individual, List };
